// extracted by mini-css-extract-plugin
module.exports = {"TabContent":"notifications-tab_TabContent__LrTZ1","EmptyContainer":"notifications-tab_EmptyContainer___M_8b","Footer":"notifications-tab_Footer__tbqVv"};